import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { SimCardDownloadOutlined } from '@mui/icons-material';
import { useLazyFetchSelfServeDataRequirementDocumentQuery } from '@api/selfServe';

interface DataRequirementDocumentChipProps {
  sx?: SxProps<Theme>;
}

const DataRequirementDocumentChip: React.FC<DataRequirementDocumentChipProps> = ({ sx }) => {
  const [fetchDataRequirementDocument] = useLazyFetchSelfServeDataRequirementDocumentQuery();

  const handleClick = async () => {
    const response = await fetchDataRequirementDocument();
    if (response.data?.data) {
      // Open in new tab
      window.open(response.data.data, '_blank');
    }
  };

  const defaultStyles: SxProps<Theme> = {
    display: 'flex',
    gap: '0.75rem',
    backgroundColor: '#F0F0F1',
    borderRadius: '0.25rem',
    padding: '0.5rem 0.625rem',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: '#162936',
    fontWeight: 700,
    alignItems: 'center',
    width: 'fit-content',
    border: '1px solid #2F736E14',
    cursor: 'pointer',
  };

  return (
    <Box sx={[defaultStyles, ...(Array.isArray(sx) ? sx : [sx])]} onClick={handleClick}>
      Data Requirement Document
      <SimCardDownloadOutlined sx={{ height: '1.25rem', width: '1.25rem' }} />
    </Box>
  );
};

export default DataRequirementDocumentChip;
